import antdCsCZ from "antd/es/locale/cs_CZ";

class LocaleProvider {
    static getPicker() {
        return antdCsCZ.DatePicker
    }
}
export default LocaleProvider;
